import request from '@/utils/axios'
import qs from 'qs'

/**
 * 根据分点id获取地点与人数
 * @param {*} params 
 * @returns 
 */
export function getByLocationId(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationandcounts/getByLocationId',
        method: 'post',
        data: postData
    })
}

/**
 * 获取地点与人数
 * @param {*} params 
 * @returns 
 */
export function getByPageAndLimit(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationandcounts/getByPageAndLimit',
        method: 'post',
        data: postData
    })
}

/**
 * 添加地点与人数
 * @param {*} params 
 * @returns 
 */
export function addLocationAndCounts(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationandcounts/addLocationAndCounts',
        method: 'post',
        data: postData
    })
}

/**
 * 修改地点与人数
 * @param {*} params 
 * @returns 
 */
export function editLocationAndCounts(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationandcounts/editLocationAndCounts',
        method: 'post',
        data: postData
    })
}

/**
 * 删除地点与人数
 * @param {*} params 
 * @returns 
 */
export function deleteLocationAndCounts(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/locationandcounts/deleteLocationAndCounts',
        method: 'post',
        data: postData
    })
}